import  API_URL from '../../constants/API_URL.js';
// import { message } from 'antd'
const axios = require('axios');
export const CLIENT_LIST = 'CLIENT_LIST';
export const CLIENT_LIST_PROGRESS = 'CLIENT_LIST_PROGRESS';

const getClientListAction = data => ({
	type: CLIENT_LIST,
	data,
});

export const clientsList =(tokenType,accessToken) => (dispatch)=>{
  dispatch({type:CLIENT_LIST_PROGRESS});

  const authOptions = {
    method: 'GET',
    url: `${API_URL}clientsList`,
    headers: {
        'Authorization': tokenType+' '+accessToken,
        'Content-Type': 'application/json'
    }
  }  
  axios(authOptions)
    .then(function (response) {
        // message.success(response.data.message)
        dispatch(getClientListAction(response.data));
      })
      .catch(function (error) {
        dispatch(getClientListAction(error))
      });

}

